export default __webpack_public_path__ + "static/media/milestone 50.b2105912.svg";